import { theme } from 'Theme';
import type { IconComponent } from 'src/icons/types';
import { AlertColours, AlertVariants } from './types';
import {
  AttentionIcon,
  HelpIcon,
  InfoIcon,
  RecommendIcon,
  SuccessIcon,
  WarningIcon,
} from '../../icons';

export const IconMap: Record<AlertVariants, IconComponent> = {
  default: InfoIcon,
  error: AttentionIcon,
  success: SuccessIcon,
  info: HelpIcon,
  warning: WarningIcon,
  recommend: RecommendIcon,
};

export const ColourMap: Record<AlertVariants, AlertColours> = {
  default: {
    primary: theme.colors.neutral.ink.base,
    background: theme.colors.neutral.grey.lightest,
  },
  error: {
    primary: theme.colors.secondary.red.base,
    background: theme.colors.secondary.red.lightest,
  },
  success: {
    primary: theme.colors.secondary.green.base,
    background: theme.colors.secondary.green.lightest,
  },
  info: {
    primary: theme.colors.secondary.blue.base,
    background: theme.colors.secondary.blue.lightest,
  },
  warning: {
    primary: theme.colors.secondary.orange.base,
    background: theme.colors.secondary.orange.lightest,
  },
  recommend: {
    primary: theme.colors.secondary.purple.dark,
    background: theme.colors.secondary.purple.lightest,
  },
};
